export default "__VITE_ASSET__DlFMHFEX__"